/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorAntecedentModel } from '../../models/patient-behavior-antecedent-model';

export interface GetPatientBehaviorAntecedents$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPatientBehaviorAntecedents(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorAntecedents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorAntecedentModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorAntecedents.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorAntecedentModel>>;
    })
  );
}

GetPatientBehaviorAntecedents.PATH = '/api/Staff/GetPatientBehaviorAntecedents';
